import React, { useState, useEffect } from 'react'
import DynamicHeader from '../Header/DynamicHeader'
import apis from '../services' 
import Loader from "../utils/Loader";
import { Loader2 } from "lucide-react";

const tabs = [
  { label: "ALL", value: "all" },
  { label: "EDUCATIONAL", value: "educational" },
  { label: "EXPLAINES", value: "explaines" }
]

const EducationalSection = () => {
  const [activeTab, setActiveTab] = useState("all")
  const [showSubscribe, setShowSubscribe] = useState(false)
  const [showPayment, setShowPayment] = useState(false)
  const [showSuccess, setShowSuccess] = useState(false)
  const [playingVideo, setPlayingVideo] = useState(null)
  const [isExplainesSubscribed, setIsExplainesSubscribed] = useState(false)

  const [videos, setVideos] = useState([]) 
  const [loading, setLoading] = useState(false)

  
  useEffect(() => {
  const fetchVideos = async () => {
  setLoading(true);

  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("token");

  let type = null;
  if (activeTab === 'educational') {
    type = 'Free';
  } else if (activeTab === 'explaines') {
    type = 'Paid';
  }

  try {
    const res = await apis.getEducationalVideos(userId, type, token);
    if (res && res.educationalVideos) {
      setVideos(res.educationalVideos);
    } else {
      setVideos([]);
    }
  } catch (err) {
    console.error('Error fetching videos:', err);
    setVideos([]);
  }
  setLoading(false);
};




    if (activeTab === 'explaines' && !isExplainesSubscribed) {
      return
    }

    fetchVideos()
  }, [activeTab, isExplainesSubscribed])

  // Tab change logic
  const handleTabClick = (tabValue) => {
    if (tabValue === 'explaines' && !isExplainesSubscribed) {
      setShowSubscribe(true)
    } else {
      setActiveTab(tabValue)
    }
  }

 
  const handlePlayClick = (video) => setPlayingVideo(video)
  const closePlayer = () => setPlayingVideo(null)

  const handlePaidClick = () => {
    if (activeTab === "explaines" && isExplainesSubscribed) {
      setShowPayment(true)
    }
  }

  const handleSubscribe = () => {
    setShowSubscribe(false)
    setIsExplainesSubscribed(true)
    setActiveTab('explaines')
  }

  const handlePayment = (e) => {
    e.preventDefault()
    setShowPayment(false)
    setShowSuccess(true)
    setTimeout(() => setShowSuccess(false), 1200)
  }

  return (
    <div>
      <div className="edu-overlay" />
      <div className="edu-content">
        <DynamicHeader />

        {/* Tabs */}
        <div className="edu-tabs">
          {tabs.map(tab => (
            <button
              key={tab.value}
              className={`edu-tab-btn ${activeTab === tab.value ? "active" : ""}`}
              onClick={() => handleTabClick(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Loading */}
        {loading && (
          <div style={{  padding: 20 , textAlign : "center"}}><Loader /></div>
        )}

        {/* Videos */}
        <div className="edu-videos-grid">
          {videos.map((video) => (
            <div key={video._id} className="edu-video-card">
              <img
                src={`https://2ab9-39-51-99-190.ngrok-free.app/${video.thumbnail}`}
                className="edu-video-thumb"
                alt={video.title}
              />

              {video.type === 'Paid' ? (
                <button className="edu-paid-btn" onClick={handlePaidClick}>
                  PAID
                </button>
              ) : (
                <button className="edu-play-btn" onClick={() => handlePlayClick(video)}>
                  ►
                </button>
              )}

              <div className="edu-video-desc">
                <div style={{ fontWeight: 600 }}>{video.title}</div>
                <div className="edu-video-footer">
                  <span>{video.createdAt?.slice(0,10)}</span>
                  <button className="edu-subscribe-btn">SUBSCRIBE</button>
                </div>
              </div>
            </div>
          ))}

          {!loading && videos.length === 0 && (
            <div style={{ color: "#fff", padding: 20, textAlign : "center" }}>No videos found.</div>
          )}
        </div>

        {/* Video Player Modal */}
        {playingVideo && (
          <div className="edu-modal-bg" onClick={closePlayer}>
            <div
              className="edu-modal"
              style={{ maxWidth: 640, padding: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <video
                width="100%"
                height="360"
                controls
                style={{ borderRadius: 18 }}
                src={playingVideo.videoLink}
              />
              <div style={{ color: "#fff", padding: 16 }}>
                <b>{playingVideo.title}</b>
              </div>
              <button className="edu-modal-cancel-btn" onClick={closePlayer}>
                Close
              </button>
            </div>
          </div>
        )}

        {/* Subscription Popup */}
        {showSubscribe && (
          <div className="edu-modal-bg">
            <div className="edu-modal">
              <div
                className="edu-modal-back"
                onClick={() => setShowSubscribe(false)}
              >
                <span>&larr;</span>
              </div>
              <h2>VIDEO</h2>
              <p>PLEASE SUBSCRIBE TO ACCESS THE SECTION</p>
              <button
                className="edu-modal-subscribe-btn"
                onClick={handleSubscribe}
              >
                SUBSCRIBE
              </button>
            </div>
          </div>
        )}

        {/* Payment Modal */}
        {showPayment && (
          <div className="edu-modal-bg">
            <form className="edu-modal" onSubmit={handlePayment}>
              <h2>Credit/Debit Card</h2>
              <div className="edu-payment-icons">
                <img src="https://upload.wikimedia.org/wikipedia/commons/4/41/Visa_Logo.png" alt="Visa" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="Mastercard" />
                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" alt="Paypal" />
                <img src="dankort.png" alt="Discover" />
              </div>
              <input className="edu-modal-input" placeholder="Card number" required />
              <input className="edu-modal-input" placeholder="Name on card" required />
              <div className="edu-modal-row">
                <input className="edu-modal-input" placeholder="MM/YY" required />
                <input className="edu-modal-input" placeholder="CVV" required />
              </div>
              <label className="edu-modal-checkbox">
                <input type="checkbox" /> Save card for future payments
              </label>
              <div className="edu-modal-actions">
                <button type="submit" className="edu-modal-submit-btn">SUBMIT</button>
                <button
                  type="button"
                  className="edu-modal-cancel-btn"
                  onClick={() => setShowPayment(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Payment Success Modal */}
        {showSuccess && (
          <div className="edu-modal-bg">
            <div className="edu-modal edu-success">
              <div className="edu-success-icon">
                <img src="/success-icon.png" alt="Success" />
              </div>
              <h2>PAYMENT SUCCESSFUL</h2>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default EducationalSection